var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import ExpansionPanelDialog from '@/components/dialog/ExpansionPanelDialog/ExpansionPanelDialog.vue';
import LabelValue from '@/components/LabelValue.vue';
import ProjectSelect from '@/components/ProjectSelect/ProjectSelect.vue';
import ErrorHandler from '@/support/ErrorHandler';
import { RpcClient } from '@/http';
import SelectGoalSetDialog from '@/components/dialog/SelectGoalSetDialog/SelectGoalSetDialog.vue';
let AssignGoalSetDialog = class AssignGoalSetDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.isFetchingTableData = false;
        this.tableItems = [];
        this.selectGoalSetDialogVisible = false;
        this.selectedStudent = null;
        this.selectedGoalSets = null;
        this.selectGoalSetDialogDescription = '';
        this.tablePagination = {
            rowsPerPage: 10,
        };
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        this.fetchCurrentGoalSets();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onClose() {
        this.$emit('close');
    }
    // #endregion
    // #region Class methods
    getHasProject(projects) {
        return !!projects && Object.keys(projects).length > 0;
    }
    getProjectsText(projects) {
        return Object.values(projects).join(', ');
    }
    setTableItems(data) {
        Object.keys(data).forEach((userId) => {
            const userData = data[userId];
            this.tableItems.push({
                id: userId,
                name: userData.name,
                projects: userData.projects,
            });
        });
    }
    onEditGoalSetForAll() {
        this.selectGoalSetDialogDescription = this.$tc('Select a goal set to add for all selected students.');
        this.selectGoalSetDialogVisible = true;
    }
    onEditGoalSetForStudent(item) {
        this.selectGoalSetDialogDescription = this.$tc('Edit the goal sets for the selected student.');
        this.selectedGoalSets = item.projects;
        this.selectedStudent = item;
        this.selectGoalSetDialogVisible = true;
    }
    onAddGoalSetForStudent(item) {
        this.selectGoalSetDialogDescription = this.$tc('Add a goal set for the selected student.');
        this.selectedStudent = item;
        this.selectGoalSetDialogVisible = true;
    }
    onCloseSelectGoalSetDialog() {
        this.selectGoalSetDialogVisible = false;
        this.selectedStudent = null;
        this.selectedGoalSets = null;
    }
    onGoalSetSelected(payload) {
        this.selectGoalSetDialogVisible = false;
        if (this.selectedStudent === null) {
            this.updateGoalSetForAllStudents(payload);
        }
        else {
            this.updateGoalSetForStudent(this.selectedStudent.id, payload);
            this.selectedStudent = null;
            this.selectedGoalSets = null;
        }
    }
    // #endregion
    // #region Async methods (api calls only)
    async updateGoalSetForStudent(studentId, payload) {
        this.isLoading = true;
        try {
            await new RpcClient().execute('add-project-to-users', {
                project: payload.projects,
                current_subjects_to_inactive: payload.disableExistingGoals,
                users: [studentId],
            });
            await this.fetchCurrentGoalSets();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    async updateGoalSetForAllStudents(payload) {
        this.isLoading = true;
        try {
            await new RpcClient().execute('add-project-to-users', {
                project: payload.projects,
                current_subjects_to_inactive: payload.disableExistingGoals,
                users: this.students.map((student) => student.id),
                for_group: true,
            });
            await this.fetchCurrentGoalSets();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    async fetchCurrentGoalSets() {
        this.isFetchingTableData = true;
        this.tableItems = [];
        try {
            const response = await new RpcClient().execute('get-projects-for-users', {
                users: this.students.map((student) => student.id),
            });
            this.setTableItems(response);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isFetchingTableData = false;
        }
    }
    // #endregion
    // #region Getters & Setters
    get expansionPanelOptions() {
        return {
            title: this.$tc('Manage goal sets'),
            description: this.$tc('Add or edit current goal sets for students.'),
            panels: [
                {
                    label: '',
                    slotName: 'panel1',
                    isOpen: true,
                    disabled: false
                },
            ],
            hasSubmitButton: false,
            secondaryButtonText: this.$tc('Close'),
        };
    }
    get tableHeaders() {
        return [
            {
                text: this.$tc('Student'),
                align: 'left',
                sortable: false,
                value: 'name',
            },
            {
                text: this.$tc('Goal set(s)'),
                align: 'left',
                sortable: false,
                value: 'projects',
            },
            {
                text: '',
                align: 'left',
                sortable: false,
                value: 'actions',
            },
        ];
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Array)
], AssignGoalSetDialog.prototype, "students", void 0);
AssignGoalSetDialog = __decorate([
    Component({
        components: {
            ExpansionPanelDialog,
            LabelValue,
            ProjectSelect,
            SelectGoalSetDialog,
        },
    })
], AssignGoalSetDialog);
export default AssignGoalSetDialog;
// #endregion
// #region Constants
// #endregion
